import { i18nEaiCodebooks } from 'models/i18n';

// ==============================|| I18N SK CODEBOOKS ||============================== //

const skEaiCodebooks: i18nEaiCodebooks = {
  INDIVIDUAL: { title: 'Fyzická osoba' },
  ORGANISATION: { title: 'Právnická osoba' },
  PRODUCER: { title: 'Výrobca' },
  CONSUMER: { title: 'Konzumer' },
  PROSUMER: { title: 'Samospotrebiteľ' },
  SUPPLIER: { title: 'Dodávateľ elektriny' },
  AGGREGATOR: { title: 'Agregátor' },
  ELECTRICITY_STORAGE_OPERATOR: {
    title: 'Prevádzkovateľ zariadenia na uskladňovanie elektriny'
  },
  ENERGY_COMMUNITY: { title: 'Energetické spoločenstvo' },
  BUYER: { title: 'Výkupca elektriny' },
  OWN: { title: 'Vlastná' },
  TRANSFERRED: { title: 'Prenesená' },
  MARKET_PARTICIPANT: {
    title: 'Účastník trhu',
    caption:
      'Podľa zákona o energetike (vlastník výrobného alebo spotrebného zariadenia, správca bilančnej skupiny)'
  },
  SERVICE_PROVIDER: {
    title: 'Poskytovateľ služby',
    caption: 'Subjekt založený za účelom poskytovania služieb účastníkom trhu'
  },
  LEVEL_0: {
    title: 'Úroveň 0'
  },
  LEVEL_1: {
    title: 'Úroveň 1'
  },
  LEVEL_2: {
    title: 'Úroveň 2',
    caption: 'Todo'
  },
  PRODUCTION_OPTIMIZATION: {
    title: 'Optimalizácia produkcie'
  },
  PRODUCTION_OPTIMIZATION_DELIVERY_POINT: {
    title: 'Optimalizácia produkcie na úrovni OOM'
  },
  PRODUCTION_OPTIMIZATION_BALANCING_GROUP: {
    title: 'Optimalizácia produkcie na úrovni bilančnej skupiny'
  },
  RESERVED_CAPACITY_GUARDING: {
    title: 'Stráženie rezervovanej kapacity'
  },
  DEVICE_PRODUCTION_PLAN_DAILY: {
    title: 'Plán produkcie na dennej báze'
  },
  DEVICE_PRODUCTION_PLAN_HOURLY: {
    title: 'Plán produkcie na hodinovej báze'
  },
  ACTIVE: {
    title: 'Aktívny'
  },
  INACTIVE: {
    title: 'Neaktívny'
  },
  BLOCKED: {
    title: 'Zablokovaný'
  },
  ENABLED: {
    title: 'Aktívny'
  },
  DISABLED: {
    title: 'Neaktívny'
  },
  OKTE_ISZO: {
    title: 'OKTE ISZO'
  },
  OKTE_ISOT: {
    title: 'OKTE ISOT'
  },
  DAMAS: {
    title: 'DAMAS'
  },
  SUPPLY_POINT: { title: 'Odovzdávacie miesto' },
  OFFTAKE_POINT: { title: 'Odberné miesto' },
  LOCAL_DISTRIBUTION_SYSTEM: { title: 'Miestna distribučná sústava' },
  INSTALLED: { title: 'Nainštalované' },
  NOT_INSTALLED: { title: 'Nenainštalované' },
  PRODUCTION: { title: 'Výrobné zariadenie' },
  CONSUMPTION: { title: 'Spotrebné zariadenie' },
  FVE: { title: 'FVE' },
  BESS: { title: 'BESS' },
  MVE: { title: 'MVE' },
  KJG: { title: 'KJG' },
  ENTIRE_AVAILABLE_CONSUMPTION_POWER_SWITCH: {
    title: 'Spínanie celého dostupného výkonu spotreby'
  },
  AVAILABLE_CONSUMPTION_POWER_STAGES_SWITCH: {
    title: 'Spínanie dostupného výkonu spotreby po stupňoch'
  },
  LINEAR_CONTINUOUS_CONSUMPTION_POWER_CHANGE_FIXED: {
    title: 'Lineárne spojitá zmena výkonu spotreby s pevnou smernicou'
  },
  LINEAR_CONTINUOUS_CONSUMPTION_POWER_CHANGE_ADJUSTABLE: {
    title: 'Lineárne spojitá zmena výkonu spotreby s nastaviteľnou smernicou'
  },
  FIXED_CONSUMPTION_PROFILE: {
    title: 'Fixný profil spotreby'
  },
  NONLINEAR_CONTINUOUS_CONSUMPTION_POWER_CHANGE: {
    title: 'Nelineárne spojitá zmena výkonu spotreby'
  },
  AMORPHOUS: { title: 'Amorfný' },
  POLYCRYSTALLINE: { title: 'Polykryštalický' },
  MONOCRYSTALLINE: { title: 'Monokryštalický' },
  REDOX: { title: 'Redox' },
  LITHIUM: { title: 'Lítium' },
  FIXED_PRICE: { title: 'Fix' },
  INDEXED_PRICE: { title: 'Index' },
  VALID: { title: 'Aktívny' },
  NOT_VALID: { title: 'Neaktívny' },
  DELETED: { title: 'Odstránené' },
  NOT_DELETED: { title: 'Aktuálne' },
  ALL: { title: 'Všetky' }
};

export default skEaiCodebooks;
